export const CHECK_SCREENING_CL = "CHECK_SCREENING_CL"
export const CHECK_SCREENING_CL_SUCCESS = "CHECK_SCREENING_CL_SUCCESS"

export const POST_DECLINE_CL = "POST_DECLINE_CL"

export const POST_ADHESION_CL = "POST_ADHESION_CL"

export const GET_DECLINE_REASONS_CL = "GET_DECLINE_REASONS_CL"
export const GET_DECLINE_REASONS_CL_SUCCESS = "GET_DECLINE_REASONS_CL_SUCCESS"

export const GET_COLLECTION_CENTER_BY_LEVEL_CL = "GET_COLLECTION_CENTER_BY_LEVEL_CL"
export const GET_COLLECTION_CENTER_BY_LEVEL_CL_SUCCESS = "GET_COLLECTION_CENTER_BY_LEVEL_CL_SUCCESS"

export const GET_GEOLOCATIONS_SUCCESS = "GET_GEOLOCATIONS_SUCCESS"

export const RESET_SCREENING_COLON_RETTO_STATE = "RESET_SCREENING_COLON_RETTO_STATE"